import * as React from 'react';
import BusinessIcon from '@material-ui/icons/Business';
import { ToDoDescriptor } from '../types';
import { useOrganizationProfileNotifications } from '@pec/aion-ui-components/hooks/useOrganizationProfileNotifications';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type RouteParams = {
  organizationId: string;
};

export const useProfileToDo = (): ToDoDescriptor[] => {
  const { statuses, isFetching, isProfileCompleted } = useOrganizationProfileNotifications();
  const { organizationId } = useParams<RouteParams>();
  const { t } = useTranslation('subscriber');

  const profileStatuses = [...statuses.contactInformationSection, ...statuses.operationDetailsSection];
  const hasIncompleteStatus = profileStatuses.some(([, value]) => value === false);

  return [
    {
      id: 'profile',
      variant: 'link',
      label: t('newDashboard.toDoWidget.companyProfile', 'Complete company profile'),
      icon: <BusinessIcon />,
      href: `/organizations/${organizationId}/profile`,
      isVisible: !isProfileCompleted && hasIncompleteStatus,
      isFetching
    }
  ];
};
